import React from 'react';

export class FormText extends React.Component {

    componentDidUpdate(prevProps) {
        const prevValue = prevProps.input.value;
        const {
            onChangeValueSideEffect,
            meta: {
                dirty,
            },
            input: {
                value: currentValue,
            },
        } = this.props;

        if ( !!onChangeValueSideEffect && dirty && currentValue !== prevValue ) {
            onChangeValueSideEffect(currentValue);
        }
    }

    render() {
        const {
            col,
            testId,
            disabled,
            placeholder,
            password,
            label,
            input: {
                value, // IMPORTANTE: si no se inicializa con un valor por defecto puede tomarlo como uncontrolled cuando redux-form envíe un undefined/null
            },
            meta: {
                touched,
                error,
            },
        } = this.props;

        const formLineClasses = `form-line ${touched && error ? 'focused error' : ''}`;

        return (
            <div className={col}>
                <div className="form-group">
                    {
                        label ? (
                            <label>{label}</label>
                        ) : null
                    }
                    <div className={formLineClasses}>
                        <input
                            test-id={testId}
                            className="form-control date"
                            value={value || ''}
                            placeholder={placeholder}
                            onChange={this.handleOnChange}
                            type={password ? 'password' : undefined}
                            disabled={disabled}
                            onBlur={this.handleOnBlur}
                        />
                    </div>
                    <label className="error">
                        {
                            touched && error ? error : ''
                        }
                    </label>
                </div>
            </div>
        );
    }

    handleOnChange = (event) => {
        const { input } = this.props;
        input.onChange(event);
    };

    handleOnBlur = (event) => {
        const { input } = this.props;
        event.target.value = String(event.target.value).trim();
        input.onChange(event);
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/components/FormText.jsx